import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "./imeges/logo1.svg";
import { Navbar, Nav, Offcanvas, Button, Container, NavDropdown } from "react-bootstrap";
import { House, Box, InfoCircle, Telephone, } from "react-bootstrap-icons"; 
import { IoWalletOutline } from "react-icons/io5"
import { useTheme } from "./ThemeContext";
// ,BookOpen
import { Sun, Moon } from "lucide-react";
import { useNavigate } from "react-router-dom";


const NavBar = () => {
  const [navbarBg, setNavbarBg] = useState("transparent");
  const [active, setActive] = useState("home");
  const [showSidebar, setShowSidebar] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();


  const routeChange = (path) => {
    setShowSidebar(false)
    navigate(path);

  };

  const handleNavClick = (section) => {
    setShowSidebar(false);
    
  
    if (window.location.pathname !== "/") {
      navigate("/", { replace: true });
  
      // Wait for navigation to complete before scrolling
      setTimeout(() => {
        document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
      }, 300); // Increase delay to ensure the section is loaded
    } else {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    }
  };
  

  useEffect(() => {
    const handleScroll = () => {
      // const scrollPosition = window.scrollY + 200;
      const sections = ["home", "services", "about", "contact","pricing"];
      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { top, bottom } = element.getBoundingClientRect();
          if (top <= 200 && bottom >= 200) {
            setActive(section);
            break;
          }
        }
      }
      // const segment = window.location.pathname.split("/")[1];
      // console.log(segment+"123")
      // console.log(window.location.pathname)
      // Get the first segment dynamically

      if (window.location.pathname === '/' || window.location.pathname === '/BotBridge-build-live/') {
        setNavbarBg(window.scrollY > 50 ? "#001351" : "transparent");
      } else {
        setNavbarBg("#001351");
      }
      
      
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
   
  return (
    
    <>
      <Navbar 
  // variant="dark"
  expand="lg" // Navbar expands from md onwards (hides toggle button)
  fixed="top"
  style={{
    backgroundColor: navbarBg,
    transition: "0.3s ease-in-out",
    height: "70px",
    padding: "0 20px",
  }}
>
  <Container fluid>
    {/* Sidebar Toggle Button (Only XS & SM) */}
    <Button
      variant="outline-light"
      className="d-lg-none  me-3"
      onClick={() => setShowSidebar(true)}
    >
      ☰
    </Button>

    {/* Logo */}
    <Navbar.Brand href="#" className="me-auto ">
      <img
        src={logo}
        loading="lazy"
        width="150"
        height="90"
        
        filter= 'brightness(0) invert(1)'
        // color="white"
        className="d-inline-block align-top ms-3"
        alt="IT Company logo"
      />
    </Navbar.Brand>

    {/* Navbar Links for MD+ Devices */}
    <Navbar.Collapse id="basic-navbar-nav ">
      <Nav className="gap-4 align-items-center">
        <Nav.Link   className={active === "home" ? "active-link" : ""} onClick={() =>handleNavClick("home")}>
          Home
        </Nav.Link>
         <Nav.Link className={active === "about" ? "active-link" : ""} onClick={() => handleNavClick("about")}>
          About
        </Nav.Link>
        <Nav.Link  className={active === "services" ? "active-link" : ""} onClick={() => handleNavClick("services")}>
          Products
        </Nav.Link>
       
        <Nav.Link  className={active === "contact" ? "active-link" : ""} onClick={() => handleNavClick("contact")}>
          Contact
        </Nav.Link>
         <Nav.Link  className={active === "pricing" ? "active-link" : ""} onClick={() =>routeChange("/pricing")}>
          Pricing
        </Nav.Link>

        {/* Dropdown */}
        <NavDropdown title="Integration Services" id="integration-services-dropdown" className="">
          {/* onClick={() => navigate("/service1")} */}
          <NavDropdown.Item >
            Third Party
          </NavDropdown.Item>
          <NavDropdown.Item>
            SAP
          </NavDropdown.Item>
         
          <NavDropdown.Item>
          Lab Analyzer       
          </NavDropdown.Item>
          <NavDropdown.Item >
            RISPACS
          </NavDropdown.Item>
         
        </NavDropdown>
        
      </Nav>
    </Navbar.Collapse>

    {/* Right-Side Icons (Only MD+ Devices) */}
    <div className="d-none d-lg-flex d-md-none align-items-center ms-auto gap-3">
      {/* <Button variant="" style={{backgroundColor:'lightblue', color:'black'}} onClick={() => routeChange("/book-demo")}>
        Book Demo
      </Button> */}

      {/* <button className="border-0 bg-transparent text-white" onClick={() => routeChange("/customer")}>
        Login <PersonCircle className="fs-4 ms-1 cursor-pointer" />
      </button> */}

      <button onClick={toggleTheme} className="border-0 bg-transparent p-2 text-white">
        {theme === "light" ? <Moon size={24} /> : <Sun size={24} />}
      </button>
    </div>
  </Container>
</Navbar>

{/* Sidebar (Only for XS & SM) */}
<Offcanvas 
  show={showSidebar} 
  onHide={() => setShowSidebar(false)} 
  placement="start" 
  className="custom-sidebar " 
  style={{ width: '160px', backgroundColor: theme === "dark" ? "#1e1e1e" : "#E2E8F0" }}
>
  <Offcanvas.Body className="d-flex flex-column align-items-start p-2 ">
    <Nav className="flex-column w-100 text-dark">
      {/* Home */}
      <Nav.Link className={`d-flex align-items-center gap-2 px-2 text-dark ${active === "home" ? "active-link" : ""}`}  onClick={() =>handleNavClick("home")}>
        <House className="icon" size={18} /> <span>Home</span>
      </Nav.Link>

        {/* About */}
      <Nav.Link className={`d-flex align-items-center gap-2 px-2 text-dark ${active === "about" ? "active-link" : ""}`} onClick={() => handleNavClick("about")}>
        <InfoCircle className="icon" size={18} /> <span>About</span>
      </Nav.Link>

      {/* Products */}
      <Nav.Link className={`d-flex align-items-center gap-2 px-2 text-dark ${active === "services" ? "active-link" : ""}`} onClick={() => handleNavClick("services")}>
        <Box className="icon" size={18} /> <span>Products</span>
      </Nav.Link>

    

      {/* Contact */}
      <Nav.Link className={`d-flex align-items-center gap-2 px-2 text-dark ${active === "contact" ? "active-link" : ""}`} onClick={() => handleNavClick("contact")}>
        <Telephone className="icon" size={18} /> <span>Contact</span>
      </Nav.Link>

        <Nav.Link className={`d-flex align-items-center gap-2 px-2 text-dark ${active === "pricing" ? "active-link" : ""}`} onClick={() => routeChange("/pricing")}>
        <IoWalletOutline className="icon" size={18} /> <span>Pricing</span>
      </Nav.Link>

      {/* Integration Services Dropdown */}
      {/* <NavDropdown 
        className={`w-100 ${active === "contact" ? "active-link" : ""}`} 
        title={<span className="d-flex align-items-center gap-2"><IoIosArrowDropdown size={18} /> Services</span>}
        id="integration-services-dropdown"
      >
        <NavDropdown.Item onClick={() => navigate("/service1")}>Third Party</NavDropdown.Item>
        <NavDropdown.Item onClick={() => navigate("/service2")}>SAP</NavDropdown.Item>
        <NavDropdown.Item onClick={() => navigate("/service3")}>Custom Software</NavDropdown.Item>
        <NavDropdown.Item onClick={() => navigate("/service4")}>Lab Analytics</NavDropdown.Item>
        <NavDropdown.Item onClick={() => navigate("/service5")}>Rispacs</NavDropdown.Item>
        <NavDropdown.Item onClick={() => navigate("/service6")}>Tally</NavDropdown.Item>
      </NavDropdown> */}

      {/* Book Demo Button */}
      {/* <Button 
        className={`d-flex align-items-center gap-2 mt-3 px-2 border-0 bg-transparent text-dark `}  
        onClick={() => routeChange('/book-demo')}
      >
        <BookOpen size={18} /> <span>Demo</span>
      </Button> */}

      {/* Profile Button */}
      {/* <button className="d-flex align-items-center gap-2 mt-3 px-2 border-0 bg-transparent text-dark" onClick={() => routeChange("/customer")}>
        <PersonCircle size={22} /> <span>Profile</span>
      </button> */}

      {/* Theme Toggle Button */}
      <button 
        onClick={toggleTheme} 
        className="d-flex align-items-center gap-2 mt-3 px-2 border-0 bg-transparent p-2 text-dark"
      >
        {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
        <span>Theme</span>
      </button>
    </Nav>
  </Offcanvas.Body>
</Offcanvas>



    </>
  );
};

export default NavBar;
